import { useState } from 'react';
import { LayoutDashboard, CalendarCheck, DollarSign, Users, Gem, UserSquare2, TrendingUp, LogOut, Clock, Zap, Settings, FileSignature } from 'lucide-react';
import { useAuth } from '../AuthContext';
import AdminGateScreen from './AdminGateScreen';
import OverviewSection from './sections/OverviewSection';
import BookingsSection from './sections/BookingsSection';
import PricingSection from './sections/PricingSection';
import MembershipsSection from './sections/MembershipsSection';
import CreditsSection from './sections/CreditsSection';
import CustomersSection from './sections/CustomersSection';
import RevenueSection from './sections/RevenueSection';
import ScheduleSection from './sections/ScheduleSection';
import AutomationsSection from './sections/AutomationsSection';
import SettingsSection from './sections/SettingsSection';
import WaiversSection from './sections/WaiversSection';

const NAV = [
  { id: 'overview', label: 'Overview', icon: LayoutDashboard, Component: OverviewSection },
  { id: 'bookings', label: 'Bookings', icon: CalendarCheck, Component: BookingsSection },
  { id: 'waivers', label: 'Waivers', icon: FileSignature, Component: WaiversSection },
  { id: 'pricing', label: 'Pricing', icon: DollarSign, Component: PricingSection },
  { id: 'memberships', label: 'Memberships', icon: Users, Component: MembershipsSection },
  { id: 'credits', label: 'Credits', icon: Gem, Component: CreditsSection },
  { id: 'customers', label: 'Customers', icon: UserSquare2, Component: CustomersSection },
  { id: 'revenue', label: 'Revenue', icon: TrendingUp, Component: RevenueSection },
  { id: 'schedule', label: 'Schedule', icon: Clock, Component: ScheduleSection },
  { id: 'automations', label: 'Automations', icon: Zap, Component: AutomationsSection },
  { id: 'settings', label: 'Settings', icon: Settings, Component: SettingsSection },
];

const WellnessAdminDashboard = () => {
  const { logout } = useAuth();
  const [active, setActive] = useState('overview');
  const Active = NAV.find((n) => n.id === active)?.Component || OverviewSection;

  return (
    <div className="min-h-screen flex" style={{ backgroundColor: '#faf7f0' }}>
      <aside className="w-60 flex-shrink-0 flex flex-col" style={{ backgroundColor: '#1f3d2b' }}>
        <div className="px-5 py-6 border-b border-white/10">
          <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#d97736]">Healthy Life Vitamins</p>
          <h1 className="text-lg text-white tracking-tight mt-1" style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 800 }}>
            Wellness Admin
          </h1>
        </div>
        <nav className="flex-1 py-4 px-3 space-y-1">
          {NAV.map(({ id, label, icon: Icon }) => (
            <button
              key={id}
              data-testid={`wellness-admin-nav-${id}`}
              onClick={() => setActive(id)}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold transition-colors ${
                active === id ? 'bg-[#d97736] text-white' : 'text-white/70 hover:bg-white/10 hover:text-white'
              }`}
            >
              <Icon size={16} /> {label}
            </button>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <button
            data-testid="wellness-admin-logout"
            onClick={logout}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold text-white/60 hover:bg-white/10 hover:text-white transition-colors"
          >
            <LogOut size={16} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 p-6 lg:p-10 overflow-y-auto">
        <div className="max-w-5xl mx-auto">
          <Active />
        </div>
      </main>
    </div>
  );
};

const WellnessAdminGate = () => {
  const { status, isAdmin } = useAuth();
  if (status === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#5a7062]" style={{ backgroundColor: '#0d1f15' }}>
        Loading…
      </div>
    );
  }
  if (!status) return <AdminGateScreen needsElevation={false} />;
  if (!isAdmin) return <AdminGateScreen needsElevation />;
  return <WellnessAdminDashboard />;
};

export default WellnessAdminGate;
